
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/favorite/star/list",
      function () {
        return require("private-next-pages/user/favorite/star/list.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/favorite/star/list"])
      });
    }
  